import { TreeSelect } from 'antd';
import type { TreeSelectProps } from 'antd';

export interface DTreeSelectProps extends TreeSelectProps {}

export const DarwinTreeSelect = (props: DTreeSelectProps) => {
  return <TreeSelect {...props} />;
};